module.exports = __webpack_public_path__ + "img/member_img01.c24703ec.jpg";